import { ReactElement, ReactNode } from 'react';
import { isDate, msToDays } from './dateUtils';

export const getParsedDate = (date: Date | string) => (isDate(date) ? date : new Date(date));
export const getDaysOverdue = (date: Date) => {
  const now = new Date();
  const diff = Math.floor(msToDays(date.getTime() - now.getTime()));

  if (diff >= 0) {
    return null;
  }

  return Math.abs(diff);
};

export const getOverdueText = (date: string | Date, suffix?: string | ReactElement): ReactNode | null => {
  const diff = getDaysOverdue(getParsedDate(date));

  if (diff === null) {
    return null;
  }

  if (!!suffix && typeof suffix === 'string') {
    return `${diff} ${suffix}`;
  }

  return (
    <>
      <span>{diff}&nbsp;</span>
      {suffix}
    </>
  );
};
